import db from '@/plugins/dexie';
import geraData from './geradata';

export default async function obterUltimaDataTabela(tabela, campoatt) {
  if (!db[tabela] || !campoatt) return '1997-01-01 13:00:00.000';
  try {
    const itens = await db[tabela].toArray();
    if (!itens || itens.length === 0) return '1997-01-01 13:00:00.000';

    let maxTs = -Infinity;
    let maxDataStr = null;
    const paraCorrigir = [];

    itens.forEach((item) => {
      const valorData = item[campoatt];
      if (valorData) {
        let valorAtual = valorData;
        if (typeof valorData === 'string' && (valorData.includes('T') || valorData.endsWith('Z'))) {
          valorAtual = geraData(valorData);
          paraCorrigir.push({ key: item.id, changes: { [campoatt]: valorAtual } });
        }

        const ts = new Date(valorAtual).getTime();
        if (!Number.isNaN(ts) && ts > maxTs) {
          maxTs = ts;
          maxDataStr = valorAtual;
        }
      }
    });

    if (paraCorrigir.length > 0) {
      try {
        await db[tabela].bulkUpdate(paraCorrigir);
      } catch (e) {
        // Ignora caso falhe atualização em lote
      }
    }

    if (maxDataStr) {
      return new Date(maxDataStr).toISOString();
    }
  } catch (err) {
    console.warn(`Erro ao obter última data da tabela ${tabela}:`, err);
  }
  return '1997-01-01 13:00:00.000';
}
